let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5yY6D")).then(() => parcelRequire('k2JVs'));